var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SelectList" }, [
    _c(
      "div",
      { staticClass: "bg-gray-200 tw-p-1" },
      [_c("FilterField", { on: { filter: _vm.onFilter } })],
      1
    ),
    _vm._v(" "),
    _vm.listExist
      ? _c(
          "ul",
          { staticClass: "list" },
          _vm._l(_vm.filteredList, function (item, index) {
            return item
              ? _c("ItemRenderer", {
                  key: item.id + index,
                  attrs: {
                    item: item,
                    itemType: _vm.itemType,
                    messages: _vm.messages,
                    level: 0,
                    isFiltered: _vm.isFiltering,
                  },
                  on: { select: _vm.onSelect, unselect: _vm.onUnselect },
                })
              : _vm._e()
          }),
          1
        )
      : _c("div", { staticClass: "text-center p-4" }, [
          _c(
            "div",
            {
              staticClass: "spinner-border text-secondary",
              attrs: { role: "status" },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("global.loading"))),
              ]),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }